module.exports = __webpack_public_path__ + "media/preview/webinar@1x-ab641375.png";